import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=eb871476&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=eb871476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../.jenkins/workspace/DMSDashboardDeployLIVE/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb871476",
  null
  
)

export default component.exports